// ★★★ PC-6 P6 — a situação de posse do lead, AO VIVO, para a tela.
//
// Assina os agendamentos (se não vierem prontos) e os recebimentos do lead, e um relógio de 1 min
// (a reserva vence e o mês vira sem ninguém mexer). ⚠ A tela só ORIENTA: quem decide é a callable
// `assumirLead`, com o que existe no banco na hora.
import { useEffect, useState } from 'react';
import { situacaoDePosse } from '@/leads/posse';
import { ouvirAgendamentosDoLead } from '@/services/agendamentosService';
import { ouvirRecebimentos } from '@/services/recebimentosService';

export function usePosse({ lead, clinicaId, papel = null, usuarioId = null, agendamentos = null, ativo = true }) {
  const [proprios, setProprios] = useState([]);
  const [temRecebimento, setTemRecebimento] = useState(false);
  const [agora, setAgora] = useState(() => new Date());
  const leadId = lead?.id;
  const assinarAgendamentos = ativo && agendamentos === null;

  useEffect(() => {
    if (!assinarAgendamentos || !clinicaId || !leadId) return undefined;
    return ouvirAgendamentosDoLead(clinicaId, leadId, setProprios, () => setProprios([]));
  }, [assinarAgendamentos, clinicaId, leadId]);

  useEffect(() => {
    if (!ativo || !clinicaId || !leadId) return undefined;
    return ouvirRecebimentos(clinicaId, leadId, (lista) => setTemRecebimento((lista ?? []).length > 0), () => setTemRecebimento(false));
  }, [ativo, clinicaId, leadId]);

  useEffect(() => {
    if (!ativo) return undefined;
    const t = setInterval(() => setAgora(new Date()), 60_000);
    return () => clearInterval(t);
  }, [ativo]);

  if (!ativo || !lead) return null;
  return situacaoDePosse(lead, {
    agendamentos: agendamentos ?? proprios,
    temRecebimento,
    agora,
    quem: { id: usuarioId, papel },
  });
}
